import { useEffect, useState } from "react";
import { Sparkles, Building2 } from "lucide-react";
import api from "../lib/api";
import { useLang } from "../context/LanguageContext";

export function ProLocked() {
  const { t } = useLang();
  return (
    <div data-testid="pro-locked" className="mx-4 md:mx-0 mt-6 bg-[#18181B] border border-[#F26722]/30 rounded-2xl p-6 flex items-start gap-3">
      <div className="w-10 h-10 rounded-xl bg-[#F26722]/15 flex items-center justify-center shrink-0"><Sparkles size={20} className="text-[#F26722]" /></div>
      <div>
        <p className="font-bold text-white">{t("Part of the Pro package")}</p>
        <p className="text-sm text-zinc-400 mt-1">{t("Planning, Dashboard and Machine checklists are a paid add-on. Contact info@rvservicetool.nl to turn it on for your company.")}</p>
      </div>
    </div>
  );
}

export function CompanyPicker({ scope }) {
  const { t } = useLang();
  const [companies, setCompanies] = useState([]);
  useEffect(() => { api.get("/companies").then(({ data }) => setCompanies(data)).catch(() => {}); }, []);
  return (
    <div className="mx-4 md:mx-0 mt-4 bg-[#18181B] border border-zinc-800 rounded-xl px-4 py-3 flex flex-wrap items-center gap-3" data-testid="pro-company-picker">
      <Building2 size={18} className="text-amber-400" />
      <span className="text-sm text-zinc-300">{t("Company")}</span>
      <select value={scope.cid} onChange={(e) => scope.setCompany(e.target.value)} data-testid="pro-company-select"
        className="bg-[#1c1c1f] border border-zinc-700 text-white rounded-lg px-3 py-2 text-sm min-w-[200px]">
        <option value="">{t("Choose a company…")}</option>
        {companies.map((c) => <option key={c.id} value={c.id}>{c.name}{c.pro_package ? " · Pro" : ""}</option>)}
      </select>
    </div>
  );
}
